import {
    UPDATE_ACTIVE_PRODUCT_FAMILY_DIALOG,
    UPDATE_INACTIVE_PRODUCT_FAMILY_DIALOG,
    CHANGE_PARTNER_SITE_SEARCH_QUERY,
    UPDATE_PRODUCT_FAMILY_PARTNER_SITE_LIST,
    UPDATE_SELECTED_PARTNER_SITE,
    UPDATE_PRODUCT_FAMILY_LIST,
    UPDATE_SELECTED_PRODUCT_FAMILY,
    SAVE_SUPPORT_TEAM,
    
    DELETE_PFPS_SUPPORT_TEAM,
    DELETE_PFPS_SUPPORT_TEAM_SUCCESS,
    DELETE_PFPS_SUPPORT_TEAM_ERROR,
    DELETE_PFPS_SUPPORT_TEAM_START, 

    CLEAR_PRODUCT_FAMILY_SELECTION,
    CLEAR_PARTNER_SITE,
    UPDATE_PRODUCT_FAMILY_PARTNER_SITE_TABLE_LIST,
    CLEAR_PRODUCT_FAMILY_PARTNER_SITE_TABLE_LIST,
    CHANGE_EDIT,
    UPDATE_EDIT,
    CHANGE_SELECT_PFPS,
    UPDATE_SELECT_PFPS,
    UPDATE_CURRENT_PAGE,
    CLEAR,
    SET_ACTIVE_PFPS_DIALOG,
    SET_INACTIVE_PFPS_DIALOG,
    CHANGE_SEARCH_VALUE,
    CHANGE_PAGE_SIZE,
    CHANGE_CURRENT_PAGE,
    UPDATE_COUNT_SIZE,
    UPDATE_PAGE_SIZE,
    UPDATE_PFPS_ROLES,

    UPDATE_SELECTED_PARTNER_SITE_FROM_PFPS,
    UPDATE_SELECTED_PRODUCT_FAMILY_FROM_PFPS,
        
    FETCH_PARTNER_SITES,
    FETCH_PARTNER_SITES_START,
    FETCH_PARTNER_SITES_SUCCESS,
    FETCH_PARTNER_SITES_ERROR,

    FETCH_PRODUCT_FAMILIES,
    FETCH_PRODUCT_FAMILIES_START,
    FETCH_PRODUCT_FAMILIES_SUCCESS,
    FETCH_PRODUCT_FAMILIES_ERROR,

    FETCH_PRODUCT_FAMILY_ENTITIES,
    FETCH_PRODUCT_FAMILY_ENTITIES_START,
    FETCH_PRODUCT_FAMILY_ENTITIES_SUCCESS,
    FETCH_PRODUCT_FAMILY_ENTITIES_ERROR,

    FETCH_PRODUCT_FAMILY_PARTNER_SITES,
    FETCH_PRODUCT_FAMILY_PARTNER_SITES_START,
    FETCH_PRODUCT_FAMILY_PARTNER_SITES_SUCCESS,
    FETCH_PRODUCT_FAMILY_PARTNER_SITES_ERROR,

    SAVE_SUPPORT_TEAM_REQUEST,
    SAVE_SUPPORT_TEAM_REQUEST_START,
    SAVE_SUPPORT_TEAM_REQUEST_SUCCESS,
    SAVE_SUPPORT_TEAM_REQUEST_ERROR,

    FETCH_PRODUCT_FAMILY_ROLES,
    FETCH_PRODUCT_FAMILY_ROLES_START,
    FETCH_PRODUCT_FAMILY_ROLES_SUCCESS,
    FETCH_PRODUCT_FAMILY_ROLES_ERROR,
} from './constants'

import {
  buildAsyncAction,
} from 'containers/Async/actions'

const setActiveProductFamilyDialog = () => ({ type: UPDATE_ACTIVE_PRODUCT_FAMILY_DIALOG, active: true })
const setInactiveProductFamilyDialog = () => ({ type: UPDATE_INACTIVE_PRODUCT_FAMILY_DIALOG, active: false })

const setActivePfpsDialog = () => ({ type: SET_ACTIVE_PFPS_DIALOG, active: true })
const setInactivePfpsDialog = () => ({ type: SET_INACTIVE_PFPS_DIALOG, active: false})

const setPartnerSiteChangeQuery = (query) => ({ type: CHANGE_PARTNER_SITE_SEARCH_QUERY, query })

const updateProductFamilyPartnerSiteList = (list) => ({ type: UPDATE_PRODUCT_FAMILY_PARTNER_SITE_LIST, list })
const updateSelectedPartnerSite = (value) => ({ type: UPDATE_SELECTED_PARTNER_SITE, value })
const updateSelectedPartnerSiteFromPfps = (value) => ({ type: UPDATE_SELECTED_PARTNER_SITE_FROM_PFPS, value })

const updateProductFamilyList = (list) => ({ type: UPDATE_PRODUCT_FAMILY_LIST, list })
const updateSelectedProductFamily = (value) => ({ type: UPDATE_SELECTED_PRODUCT_FAMILY, value })
const updateSelectedProductFamilyFromPfps = (value) => ({ type: UPDATE_SELECTED_PRODUCT_FAMILY_FROM_PFPS, value })

const updateProductFamilyPartnerSiteTableList = (list) => ({ type: UPDATE_PRODUCT_FAMILY_PARTNER_SITE_TABLE_LIST, list })
const clearProductFamilyPartnerSiteTableList = () => ({ type: CLEAR_PRODUCT_FAMILY_PARTNER_SITE_TABLE_LIST })

const saveSupportTeam = () => ({ type: SAVE_SUPPORT_TEAM })

const deletePfpsSupportTeam = () => ({ type: DELETE_PFPS_SUPPORT_TEAM })
const deletePfpsSupportTeamStart = () => ({ type: DELETE_PFPS_SUPPORT_TEAM_START })
const deletePfpsSupportTeamSuccess = () => ({ type: DELETE_PFPS_SUPPORT_TEAM_SUCCESS })
const deletePfpsSupportTeamError = () => ({ type: DELETE_PFPS_SUPPORT_TEAM_ERROR })
const startDeleteSupportTeamAsync = buildAsyncAction(
  DELETE_PFPS_SUPPORT_TEAM,
  DELETE_PFPS_SUPPORT_TEAM_START,
  [DELETE_PFPS_SUPPORT_TEAM_SUCCESS, DELETE_PFPS_SUPPORT_TEAM_ERROR]
)

const clearProductFamilySelection = () => ({ type: CLEAR_PRODUCT_FAMILY_SELECTION })
const clearPartnerSite = () => ({ type: CLEAR_PARTNER_SITE })

const changeEdit = (enable) => ({ type: CHANGE_EDIT, enable })
const updateEdit = (enable) => ({ type: UPDATE_EDIT, enable })
const updateCurrentPage = (page) => ({ type: UPDATE_CURRENT_PAGE, page })
const clear = () => ({ type: CLEAR })

const updatePfpsRoles = (roles) => ({ type: UPDATE_PFPS_ROLES, roles })


const updateCountSize = (count) => ({ type: UPDATE_COUNT_SIZE, count })
const changePageSize = (size) => ({ type: CHANGE_PAGE_SIZE, size })
const updatePageSize = (size) => ({ type: UPDATE_PAGE_SIZE, size })
const incrementPage = () => ({ type: CHANGE_CURRENT_PAGE, value: 1 })
const decrementPage = () => ({ type: CHANGE_CURRENT_PAGE, value: -1 })

const changeSearchValue = (value) => ({ type: CHANGE_SEARCH_VALUE, value })

const changeSelectPfps = (id) => ({ type: CHANGE_SELECT_PFPS, id })
const updateSelectPfps = (id) => ({ type: UPDATE_SELECT_PFPS, id })

const fetchPartnerSites = () => ({ type: FETCH_PARTNER_SITES })
const fetchPartnerSitesStart = () => ({ type: FETCH_PARTNER_SITES_START })
const fetchPartnerSitesSuccess = () => ({ type: FETCH_PARTNER_SITES_SUCCESS })
const fetchPartnerSitesError = (error) => ({ type: FETCH_PARTNER_SITES_ERROR, error })
const startFetchPartnerSitesAsync = buildAsyncAction(
  FETCH_PARTNER_SITES,
  FETCH_PARTNER_SITES_START,
  [FETCH_PARTNER_SITES_SUCCESS, FETCH_PARTNER_SITES_ERROR]
)

const fetchProductFamilyEntities = () => ({ type: FETCH_PRODUCT_FAMILY_ENTITIES })
const fetchProductFamilyEntitiesStart = () => ({ type: FETCH_PRODUCT_FAMILY_ENTITIES_START })
const fetchProductFamilyEntitiesSuccess = () => ({ type: FETCH_PRODUCT_FAMILY_ENTITIES_SUCCESS })
const fetchProductFamilyEntitiesError = (error) => ({ type: FETCH_PRODUCT_FAMILY_ENTITIES_ERROR, error })
const startFetchProductFamilyEntitiesAsync = buildAsyncAction(
  FETCH_PRODUCT_FAMILY_ENTITIES,
  FETCH_PRODUCT_FAMILY_ENTITIES_START,
  [FETCH_PRODUCT_FAMILY_ENTITIES_SUCCESS, FETCH_PRODUCT_FAMILY_ENTITIES_ERROR]
)

const fetchProductFamilies = () => ({ type: FETCH_PRODUCT_FAMILIES })
const fetchProductFamiliesStart = () => ({ type: FETCH_PRODUCT_FAMILIES_START })
const fetchProductFamiliesSuccess = () => ({ type: FETCH_PRODUCT_FAMILIES_SUCCESS })
const fetchProductFamiliesError = (error) => ({ type: FETCH_PRODUCT_FAMILIES_ERROR, error })
const startFetchProductFamiliesAsync = buildAsyncAction(
  FETCH_PRODUCT_FAMILIES,
  FETCH_PRODUCT_FAMILIES_START,
  [FETCH_PRODUCT_FAMILIES_SUCCESS, FETCH_PRODUCT_FAMILIES_ERROR]
)

const fetchProductFamilyPartnerSite = () => ({ type: FETCH_PRODUCT_FAMILY_PARTNER_SITES })
const fetchProductFamilyPartnerSiteStart = () => ({ type: FETCH_PRODUCT_FAMILY_PARTNER_SITES_START })
const fetchProductFamilyPartnerSiteSuccess = () => ({ type: FETCH_PRODUCT_FAMILY_PARTNER_SITES_SUCCESS })
const fetchProductFamilyPartnerSiteError = (error) => ({ type: FETCH_PRODUCT_FAMILY_PARTNER_SITES_ERROR, error })
const startFetchProductFamilyPartnerSiteAsync = buildAsyncAction(
  FETCH_PRODUCT_FAMILY_PARTNER_SITES,
  FETCH_PRODUCT_FAMILY_PARTNER_SITES_START,
  [FETCH_PRODUCT_FAMILY_PARTNER_SITES_SUCCESS, FETCH_PRODUCT_FAMILY_PARTNER_SITES_ERROR]
)

const saveSupportTeamRequest = () => ({ type: SAVE_SUPPORT_TEAM_REQUEST })
const saveSupportTeamRequestStart = () => ({ type: SAVE_SUPPORT_TEAM_REQUEST_START })
const saveSupportTeamRequestSuccess = () => ({ type: SAVE_SUPPORT_TEAM_REQUEST_SUCCESS })
const saveSupportTeamRequestError = () => ({ type: SAVE_SUPPORT_TEAM_REQUEST_ERROR })
const startSaveSupportTeamAsync = buildAsyncAction(
  SAVE_SUPPORT_TEAM_REQUEST,
  SAVE_SUPPORT_TEAM_REQUEST_START,
  [SAVE_SUPPORT_TEAM_REQUEST_SUCCESS, SAVE_SUPPORT_TEAM_REQUEST_ERROR]
)

const fetchProductFamilyRoles = () => ({ type: FETCH_PRODUCT_FAMILY_ROLES })
const fetchProductFamilyRolesStart = () => ({ type: FETCH_PRODUCT_FAMILY_ROLES_START })
const fetchProductFamilyRolesSuccess = () => ({ type: FETCH_PRODUCT_FAMILY_ROLES_SUCCESS })
const fetchProductFamilyRolesError = () => ({ type: FETCH_PRODUCT_FAMILY_ROLES_ERROR })
const fetchProductFamilyRolesAsync = buildAsyncAction(
  FETCH_PRODUCT_FAMILY_ROLES,
  FETCH_PRODUCT_FAMILY_ROLES_START,
  [FETCH_PRODUCT_FAMILY_ROLES_SUCCESS, FETCH_PRODUCT_FAMILY_ROLES_ERROR]
)

export {
    setActiveProductFamilyDialog,
    setInactiveProductFamilyDialog,
    setPartnerSiteChangeQuery,
    updateProductFamilyPartnerSiteList,
    updateSelectedPartnerSite,
    updateProductFamilyList,
    updateSelectedProductFamily,
    saveSupportTeam,

    deletePfpsSupportTeam,
    startDeleteSupportTeamAsync,
    deletePfpsSupportTeamStart,
    deletePfpsSupportTeamSuccess,
    deletePfpsSupportTeamError,

    clearProductFamilySelection,
    clearPartnerSite,
    updateProductFamilyPartnerSiteTableList,
    clearProductFamilyPartnerSiteTableList,
    updateCurrentPage,
    clear,
    changeEdit,
    updateEdit,
    changeSelectPfps,
    updateSelectPfps,
    setActivePfpsDialog,
    setInactivePfpsDialog,
    changeSearchValue,
    incrementPage,
    decrementPage,
    changePageSize,
    updateCountSize,
    updatePageSize,

    updatePfpsRoles,


    updateSelectedPartnerSiteFromPfps,
    updateSelectedProductFamilyFromPfps,

    fetchPartnerSites,
    fetchPartnerSitesStart,
    fetchPartnerSitesSuccess,
    fetchPartnerSitesError,
    startFetchPartnerSitesAsync,

    fetchProductFamilies,
    fetchProductFamiliesStart,
    fetchProductFamiliesError,
    fetchProductFamiliesSuccess,
    startFetchProductFamiliesAsync,

    fetchProductFamilyEntities,
    fetchProductFamilyEntitiesStart,
    fetchProductFamilyEntitiesSuccess,
    fetchProductFamilyEntitiesError,
    startFetchProductFamilyEntitiesAsync,

    fetchProductFamilyPartnerSite,
    fetchProductFamilyPartnerSiteStart,
    fetchProductFamilyPartnerSiteSuccess,
    fetchProductFamilyPartnerSiteError,
    startFetchProductFamilyPartnerSiteAsync,

    saveSupportTeamRequest,
    saveSupportTeamRequestStart,
    saveSupportTeamRequestSuccess,
    saveSupportTeamRequestError,
    startSaveSupportTeamAsync,
    
    fetchProductFamilyRoles,
    fetchProductFamilyRolesStart,
    fetchProductFamilyRolesSuccess,
    fetchProductFamilyRolesError,
    fetchProductFamilyRolesAsync,
}